import React, { useRef } from 'react';
import emailjs from 'emailjs-com';

export const Form = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_duel1u9', 'template_cj0dqoe', form.current, 'EDbgUl1UsJkVBLTYr')
      .then((result) => {
          console.log(result.text);
          
      }, (error) => {
          console.log(error.text);
      });
    form.reset(); 
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
    <div className="hero min-h-screen ">
     <div className="hero-content flex-col w-96">
         <div className="text-center lg:text-left">
         <h1 className="text-5xl font-bold">Let's Chat!</h1>
         
         </div>
         <div className="card w-full  shadow-2xl bg-base-100">
         <div className="card-body">
             <div className="form-control">
             <label className="label">
                 <span className="label-text">Name</span>
             </label>
             <input type="text" placeholder="Name" className="input input-bordered" name="user_name"/>
             </div>
             <div className="form-control">
             <label className="label">
                 <span className="label-text">Email</span>
             </label>
             <input type="email" placeholder="email" className="input input-bordered" name="user_email"/>
             </div>
             <div className="form-control">
             <label className="label">
                 <span className="label-text">message</span>
             </label>
             {/* <input type="text" placeholder="message" className="input input-bordered" name="message"/> */}
             <textarea type="text"  className="input input-bordered p-10" rows="3" name="message"></textarea>
             </div>
             <div className="form-control mt-6">
             <button type="submit" value="Send"  className="btn">Submit</button>
             
             </div>
         </div>
         </div>
     </div>
     </div>
  
   
 </form>

    



  );
};